module.exports = __webpack_public_path__ + "img/onboarding-footer-light.759a6768.svg";